"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserType = void 0;
var UserType;
(function (UserType) {
    UserType[UserType["AccountAdmin"] = 1] = "AccountAdmin";
    UserType[UserType["AccountUser"] = 2] = "AccountUser";
    UserType[UserType["DistrictUser"] = 4] = "DistrictUser";
    UserType[UserType["FieldUser"] = 8] = "FieldUser";
    UserType[UserType["FacilityUser"] = 16] = "FacilityUser";
    UserType[UserType["FieldAdmin"] = 32] = "FieldAdmin";
    UserType[UserType["SystemAdmin"] = 64] = "SystemAdmin";
})(UserType = exports.UserType || (exports.UserType = {}));
//# sourceMappingURL=UserType.js.map